<template>
  <div>
    <div class="row">
      <!--  Text Area -->

      <div v-if="show.includes('exitSought')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Exit Sought</label>
          <p>
            <small
              >An exit strategy is the process of disposing of a business asset
              once specific criteria has been met.</small
            >
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="exitSought"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('investorVision')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Investor Vision</label>
          <p>
            <small
              >The motives the investor has with respect to attaining new
              business assets.</small
            >
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="investorVision"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('investorFundingGoals')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Investor Funding Goals</label>
          <p><small>The providers overall aims.</small></p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="investorFundingGoals"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('region')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Region</label>
          <p>
            <small>The region of the world the provider operates in.</small>
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="region"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('entrepreneurialExperience')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Entrepreneurial Experience</label>
          <p>
            <small
              >Experience the provider have investing and supporting
              entrepreneurial ventures.</small
            >
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="entrepreneurialExperience"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('technicalExperience')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Technical Experience</label>
          <p>
            <small
              >Experience the provider has supporting technical aspects of
              ventures.</small
            >
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="technicalExperience"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>

      <div v-if="show.includes('additionalServices')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Additional Services</label>
          <p>
            <small>Any additional services the provider may provide.</small>
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <textarea
              style="border-radius: 5px;"
              class="form-control"
              v-model="additionalServices"
              type="text"
              rows="2"
              maxlength="500"
            />
          </div>
        </div>
      </div>
      <!--  Text Input -->

      <div v-if="show.includes('applicationProcess')">
        <div class="form-group col-md-12" style="margin: 0px;">
          <label>Application Process</label>
          <p>
            <small
              >Link to online application process or description of application
              instructions</small
            >
          </p>
          <div class="form-group input-group" style="width: 100%;">
            <input
              style="border-radius: 5px;"
              class="form-control"
              v-model="applicationProcess"
              type="url"
              placeholder="https://example.com/application-process"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "./textInput.vue";
import utils from "../components/utils.js";

export default {
  name: "provider-page",
  components: {
    textInput: textInput
  },
  props: ["show"],
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain"
    }),
    exitSought: {
      set: function(editedData) {
        this.setDescValue(1)(editedData);
      },
      get: function() {
        return this.getDescValue(1);
      }
    },
    investorVision: {
      set: function(editedData) {
        this.setDescValue(2)(editedData);
      },
      get: function() {
        return this.getDescValue(2);
      }
    },
    investorFundingGoals: {
      set: function(editedData) {
        this.setDescValue(3)(editedData);
      },
      get: function() {
        return this.getDescValue(3);
      }
    },
    region: {
      set: function(editedData) {
        this.setDescValue(4)(editedData);
      },
      get: function() {
        return this.getDescValue(4);
      }
    },
    entrepreneurialExperience: {
      set: function(editedData) {
        this.setDescValue(5)(editedData);
      },
      get: function() {
        return this.getDescValue(5);
      }
    },
    technicalExperience: {
      set: function(editedData) {
        this.setDescValue(6)(editedData);
      },
      get: function() {
        return this.getDescValue(6);
      }
    },
    additionalServices: {
      set: function(editedData) {
        this.setDescValue(7)(editedData);
      },
      get: function() {
        return this.getDescValue(7);
      }
    },
    applicationProcess: {
      set: function(editedData) {
        this.setDescValue(9)(editedData);
      },
      get: function() {
        return this.getDescValue(9);
      }
    }
  },
  methods: {
    ...mapMutations({
      deleteProperty: "deleteEditedProviderPropertyByKeyChain",
      setProperty: "setEditedProviderByKeyChain"
    }),
    getDescValue: function(i) {
      var value = this.getProperty([
        "provider_descriptions",
        {
          filterField: "description_id",
          filterValue: i
        },
        "value"
      ]);
      if (value) {
        return value;
      } else {
        return "";
      }
    },
    setDescValue: function(i) {
      var self = this;
      var f = function(editedData) {
        var value = self.getProperty([
          "provider_descriptions",
          {
            filterField: "description_id",
            filterValue: i
          }
        ]);
        if (value) {
          // edit
          var index = self
            .getProperty(["provider_descriptions"])
            .findIndex(desc => {
              return desc.description_id == value.description_id;
            });
          self.setProperty({
            data: editedData,
            keyChain: ["provider_descriptions", index, "value"]
          });
        } else {
          if (editedData != "") {
            // create
            var vals = self.getProperty(["provider_descriptions"]);
            var desc = _createDescObj(i);
            desc.value = editedData;
            vals.push(desc);
            self.setProperty({
              data: vals,
              keyChain: ["provider_descriptions"]
            });
          }
        }
      };
      return f;
    }
  }
};

function _createDescObj(i) {
  return {
    description: {
      id: i
    },
    description_id: i,
    value: undefined
  };
}
</script>



// WEBPACK FOOTER //
// src/elements/descs.vue